import $ from 'jquery';
import 'jquery-once';

const Drupal = global.Drupal;

/**
 * Check types of items in array
 * @param  {array} args
 * @param  {array} types
 */
function checkTypes(args, types) {
  args.forEach((arg, i) => {
    if ( typeof arg !== types[i] ) {
      throw new TypeError(`param ${arg} must be a ${types[i]}, but received ${typeof arg}`);
    }
  });
}

/**
 * Creates behavior function with specified name
 * which will find element by jQuery selector
 * filter it through once plugin by same name
 * run attachment function with filtered items
 * as an argument also providing
 * Drupal.settings and context
 *
 * @param  {string} selector
 * @param  {string} name
 * @param  {function} attachment
 */
export default (selector, name, attachment) => {
  checkTypes([selector, name, attachment], ['string', 'string', 'function']);

  if (Drupal.behaviors[name] !== undefined) {
    throw new Error(`name "${name}" is already taken. Drupal behavior name must be unique across whole application.`);
  }

  Drupal.behaviors[name] = {
    attach: (context, settings) => {
      const $items = $(selector, context).once(name);

      if (!$items.length) {
        return;
      }

      Array.prototype.forEach.call($items, (item) => {
        const $this = $(item);
        const instance = new attachment($this, context, settings);

        $this.data('behaviorInstance', instance);
      });
    }
  };
}





// WEBPACK FOOTER //
// ./js/src/create-behavior.js